import { useEffect, useState } from 'react';
import {
  addNetworkListener,
  getNetworkStatus,
  type NetworkStatus,
} from '@/mobile/services/network.service';

export function useNetworkStatus(): NetworkStatus {
  const [status, setStatus] = useState<NetworkStatus>({
    connected: true,
    connectionType: 'unknown',
  });

  useEffect(() => {
    void getNetworkStatus().then(setStatus);
    return addNetworkListener(setStatus);
  }, []);

  return status;
}
